import React from 'react'
import Link from 'gatsby-link'

const Header = () => (
  <header name='top'>
    <h1>Jared Silver</h1>
    <img id='headshot' src={`${__PATH_PREFIX__}/jaredsilver.jpg`} />
    <nav className='desktop-only'>
      <Link to='/mission' data-section='Mission'><img src={`${__PATH_PREFIX__}/icons/mission.png`} /></Link>
      <Link to='/work' data-section='Work'><img src={`${__PATH_PREFIX__}/icons/projects.png`} /></Link>
      <Link to='/thoughts' data-section='Thoughts'><img src={`${__PATH_PREFIX__}/icons/thoughts.png`} /></Link>
      <Link to='/inspiration' data-section='Inspiration'><img src={`${__PATH_PREFIX__}/icons/inspiration.png`} /></Link>
    </nav>
    <nav className='mobile-only'>
      <Link to='/mission' data-section='Mission'><img src={`${__PATH_PREFIX__}/icons/mission.png`} /></Link>
      <Link to='/work' data-section='Work'><img src={`${__PATH_PREFIX__}/icons/projects.png`} /></Link>
      <Link to='/thoughts' data-section='Thoughts'><img src={`${__PATH_PREFIX__}/icons/thoughts.png`} /></Link>
      <Link to='/inspiration' data-section='Inspiration'><img src={`${__PATH_PREFIX__}/icons/inspiration.png`} /></Link>
    </nav>
    <section id='callout-box'>
      <h2>Education is the best way to improve access to opportunity.</h2>
      <h2>Technology is the best way to improve access to education.</h2>
      <h2>Education technology is the best way to improve the world.</h2>
    </section>
  </header>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/header.js